import React, { CSSProperties } from 'react';

interface IProps {
  /**
   * Svg's height
   * @default "68"
   */
  height?: string;

  /**
   * Svg's width
   * @default "255"
   */
  width?: string;

  /**
   * Svg's classNames
   * @default ''
   */
  className?: string;

  /**
   * Svg's style
   * @default ''
   */
  style?: CSSProperties;

  /**
   * Svg's style
   * @default '#1C1C1C'
   */
  textColor: string;
  fillColor?: string;
}

const LogoIcon = ({
  width,
  height,
  className,
  style,
  textColor,
  fillColor
}: IProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={width}
    height={height}
    className={className}
    style={style}
    viewBox="0 0 255 68"
  >
    <defs>
      <path id="prefix__a" d="M0.725 0.6L36.623 0.6 36.623 52 0.725 52z" />
      <path
        id="prefix__c"
        d="M0.391 0.557L10.49 0.557 10.49 51.666 0.391 51.666z"
      />
      <path
        id="prefix__e"
        d="M0.045 0.6L26.59 0.6 26.59 35.908 0.045 35.908z"
      />
      <path id="prefix__g" d="M0 0.277L64.971 0.277 64.971 65.755 0 65.755z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(74 16)">
        <mask id="prefix__b" fill="#fff">
          <use xlinkHref="#prefix__a" />
        </mask>
        <path
          fill={textColor}
          d="M36.623 18.414c0 10.878-7.662 17.741-16.928 17.741-4.815 0-9.558-1.898-11.82-5.767V52H.725V1.33h7.15V6.44C10.137 2.571 15.1.6 19.695.6c9.193 0 16.928 6.936 16.928 17.814m-7.223.073c0-6.424-4.67-11.17-10.58-11.17-5.691 0-10.872 4.307-10.872 11.17 0 6.863 5.62 10.88 10.873 10.88 5.909 0 10.579-4.455 10.579-10.88"
          mask="url(#prefix__b)"
        />
      </g>
      <path
        fill={textColor}
        d="M115 34.393C115 23.755 122.985 17 132.465 17S150 23.755 150 34.393C150 45.03 141.944 52 132.465 52 122.985 52 115 45.029 115 34.393m28.014 0c0-6.468-4.847-10.781-10.549-10.781-5.703 0-10.48 4.313-10.48 10.781 0 6.54 4.777 10.923 10.48 10.923 5.702 0 10.55-4.383 10.55-10.923"
      />
      <g transform="translate(154)">
        <mask id="prefix__d" fill="#fff">
          <use xlinkHref="#prefix__c" />
        </mask>
        <path
          fill={textColor}
          d="M.39 5.156c0-2.627 2.337-4.6 5.05-4.6 2.789 0 5.05 1.973 5.05 4.6 0 2.629-2.261 4.6-5.05 4.6-2.713 0-5.05-1.971-5.05-4.6zm1.356 46.51h7.386V17.568H1.746v34.098z"
          mask="url(#prefix__d)"
        />
      </g>
      <path
        fill={textColor}
        d="M202 32.408V52h-7.177V32.922c0-5.577-3.369-8.804-7.762-8.804-4.466 0-9.885 2.492-9.885 9.61V52H170V17.734h7.176v5.282c1.977-4.182 7.469-6.016 11.129-6.016 8.642 0 13.768 5.649 13.694 15.408M210.329 37.51V23.965H204v-5.972h6.329v-8.81L217.713 7v10.994h7.384v5.972h-7.384v13.398c-.076 3.86.83 7.937 6.255 7.937H226V52h-2.786c-9.57 0-12.885-5.753-12.885-14.49"
      />
      <g transform="translate(228 16)">
        <mask id="prefix__f" fill="#fff">
          <use xlinkHref="#prefix__e" />
        </mask>
        <path
          fill={textColor}
          d="M6.718 24.889c0 2.682 2.42 5.002 6.306 5.002 3.961 0 6.38-1.814 6.38-4.351 0-2.248-1.832-3.407-4.399-3.987l-4.621-1.087C4.002 18.8 1.07 15.534 1.07 10.533 1.07 5.024 6.13.6 13.246.6c5.866 0 12.172 3.045 12.172 10.149h-6.896c0-2.464-2.564-4.13-5.131-4.13-3.007 0-5.063 1.812-5.063 4.13 0 2.104 1.982 3.263 4.109 3.77l5.207 1.233c7.333 1.814 8.948 6.309 8.948 9.935 0 6.452-6.457 10.221-13.495 10.221-6.38 0-12.907-3.987-13.052-11.02h6.673z"
          mask="url(#prefix__f)"
        />
      </g>
      <g transform="translate(0 1)">
        <mask id="prefix__h" fill="#fff">
          <use xlinkHref="#prefix__g" />
        </mask>
        <path
          fill={fillColor}
          d="M64.971 33.016c0 18.082-14.544 32.739-32.486 32.739C14.545 65.755 0 51.098 0 33.016 0 14.934 14.545.277 32.485.277c17.942 0 32.486 14.657 32.486 32.739"
          mask="url(#prefix__h)"
        />
      </g>
      <path
        fill={textColor}
        d="M64 25.905c-.261-.944-.563-1.87-.906-2.777l-.06.025c-.895 1.14-2.084 1.771-3.061 2.862-1.115 1.243-2.056 2.63-3.16 3.88-1.778 2.01-3.588 3.989-5.432 5.936-2.508 2.649-5.074 5.24-7.7 7.77-5.102 4.914-11.767 8.652-18.656 4.564.012.037.006.086-.03.104-.078.037-.167-.018-.232-.071-1.408-1.123-4.518-5.4-2.574-7.133.813-.726 2.966-1.007 4.013-1.401 2.641-.989 5.238-2.116 7.69-3.52 3.874-2.217 7.409-5.171 9.79-8.955 2.05-3.261 3.15-7.57 1.277-10.937-2.25-4.047-7.617-4.877-11.741-3.853-.009-.053.176-.051.166-.098-.43.071-.858.153-1.283.244-.448.12-.902.23-1.348.37.146-.024.298-.028.446-.04.107.17-.623.57-1.052.645.462-.362-.063-.297-.353-.35-.312.242.38.05.235.232-.395.295-1.248.801-1.512.83.067-.071.138-.139.213-.204-.527.366-.965.194-1.506.541-.387.456-.82.56-.519.792-.614.529-.395-.016-.628.11-.217.356-1.147.982-1.372.95.004.665-1.693 1.355-1.472 1.794-.21.098-.42.2-.618.31.075.093.192.368-.106.787-.409.286-.49.07-.679.107l.146.531c-.523.466-1.015 1.024-1.481 1.632-.462.592-.949 1.337-1.36 2.063-.846 1.473-1.508 3.051-2.157 4.461-.338 1.347-.533 3.05-.847 4.572l-.027-.181c-.123.502-.249 1.009-.35 1.513.113-.362.233-.722.363-1.08-.004.342.038.612-.006.934-.167 1.163.117 2.813-.444 3.873-.61 1.156-2.19 1.343-3.594 1.314-.712.657-1.768.824-2.742.94l-.501.061c-1.346.161-2.71.328-3.975.82-.213.084-.436.177-.663.157-.35-.035-.638-.336-.989-.352-.257-.01-.492.134-.731.232-.465.187-.965.201-1.472.177.253 1.263.584 2.5.977 3.708.519.041 1.04.082 1.557.116.468-.158.952-.266 1.443-.319-.162.09-.325.177-.485.266 1.966-.46 4.003-.506 6.004-.797 1.642-.24 3.219-.848 4.82-1.123.257 2.502 2.173 6.138 3.86 8.001 2.06 2.279 4.868 3.892 7.853 4.574 9.565 2.183 18.155-3.241 23.839-10.52 2.918-3.656 8.33-11.519 10.386-14.778 1-1.628 1.941-3.068 2.746-4.309M21.435 36.388l.065-.053-.002-.004-.06-.211c.405.095.184-1.392.43-1.756.021-.637.048-1.861.358-2.767.247-.122.535-1.237.875-1.88.19-.675.477-1.468.831-2.274.367-.808.82-1.58 1.34-2.293l-.245-.124.263-.413c.045.039.108.004.09.082.46-.135.57-.963.956-1.144-.342.033-.233.236-.4.452-.334.244-.325-.224.106-.564l.039.045.113-.37c.19.102.467-.094.653.01.934-1.178 1.405-2.17 2.66-2.999.007.265.834-.653.818-.142.637-.608-.298-.2-.12-.667.213-.126.392-.344.505-.236-.052.14.294.118.14.25.162-.104.322-.22.495-.303.063.006-.027.11-.071.16.96-.752 1.986-.553 2.945-.998.046-.163-.42.046-.38-.114.497-.265.749-.255.994-.2.245.055.462.078.969-.055l-.195.216c.312-.157.46-.35 1.002-.216.107.23-.448.228-.696.356.179-.004.515-.05.736-.095.215-.04.365-.112.237-.222.414-.09.513.169.71.234.014-.057-.333-.183-.106-.28.505.172 1.162.325 1.443.518-.03.053-.056.144-.09.155.372-.137.074.3.242.382.1.081.215.193.333.456.111.258.196.659.199 1.137.006.96-.309 2.146-.817 3.07.093.557-.236 1.186-.572 1.819l-.391-.171c-.065.189-.148.37-.223.557-.24.12.194-.41-.176-.163l.085.336c-.142-.045-1.014 1.117-.637.165-.235.293-.474.58-.73.854-.25.293-.512.476-.76.727-.352.299.07.457-.46.718-.168-.027.112-.187-.02-.277-1.504.761-1.147 1.851-2.722 2.6l.1-.12c-.203.244-.704.513-.682.568.408.258.16-.356.75-.403.142.331-.484.498-.318.716-.426.094-.54.393-.845.592-.65.1-1.385.639-1.928.604-.217.244-.373.712-.975 1.003-.55-.055-.012-.29-.642-.114l-.008.234c-.495.193-.444.106-.467.008-.514.23-.31.464-1.021.619l.286-.34c-.454.279-.667.33-1.35.602-.03-.118.243-.226.454-.279-.485-.128-.576.391-.789.446.091.059.576-.104.424.185-.35.108-.61.57-.949.431l.296-.333c-.648.433-.281.392-1.13.639.038-.033-.003-.072.001-.118-.411.43-1.137.5-1.893.732-.024.008-.046.012-.073.02"
      />
    </g>
  </svg>
);

LogoIcon.defaultProps = {
  width: '255',
  height: '68',
  textColor: '#1C1C1C',
  className: '',
  fillColor: '#00B451'
};

export default LogoIcon;
